/**
 * 组件的emit事件声明
 */
export const emits = [
  /** 滚动条与底部距离小于 offset 时触发 */
  'load',
  /** 更新加载状态 */
  'update:loading',
  /** 更新加载失败状态 */
  'update:error',
];

